import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import { Form } from 'react-bootstrap';

import * as _ from 'lodash';
import { mapIndustryList } from 'utils/config';
import { makeGetAnalUserFilter } from 'lib/selector';
import RenderFieldCheckbox from 'components/input/renderCheckbox';
import RenderMultiSelect from 'components/input/renderMultiSelect';
// import { log } from 'utils';

function usePrevious(value) {
  const ref = React.useRef();

  React.useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

function FormSearchFilter(props) {
  const dispatch = useDispatch();

  const {
    setHeaderFilter,

    formChkApec,
    formPersonalFilter,
    typeIndustry,
    typeHOSE,
    typeHNX,
    typeUPCOM,
    analUserFilter,
    t,
    theme
  } = props;

  const preUserFilter = usePrevious(analUserFilter);

  React.useEffect(() => {
    if (
      typeIndustry !== undefined &&
      typeHOSE !== undefined &&
      typeHNX !== undefined &&
      typeUPCOM !== undefined
    ) {
      let _typeIndex = '';
      if (typeHOSE) _typeIndex = 'HOSE,';
      if (typeHNX) _typeIndex += 'HNX,';
      if (typeUPCOM) _typeIndex += 'UPCOM,';

      const _filter = _.find(
        analUserFilter,
        (o) => o.FilterId == formPersonalFilter
      );

      const _fil = {
        filter: formPersonalFilter || '',
        name: _filter?.Name || (formChkApec === '1' ? 'APEC' : ''),
        index: _typeIndex ? _typeIndex.slice(0, -1) : 'HOSE',
        industry: typeIndustry,
      };
      // log(_fil);
      setHeaderFilter(_fil);
    }
  }, [typeIndustry, typeHOSE, typeHNX, typeUPCOM]);

  React.useEffect(() => {
    if (formPersonalFilter) {
      dispatch(change('formHeaderSearchfilter', 'formChkApec', '0'));

      const _filter = _.find(
        analUserFilter,
        (o) => o.FilterId == formPersonalFilter
      );
      // log(_filter);
      if (_filter) {
        const _filterIndex = _filter?.ExchangeCode?.split(',') || ['HOSE', 'HNX', 'UPCOM'];
        dispatch(change('formHeaderSearchfilter', 'typeHOSE', _.some(_filterIndex, o => o === 'HOSE')));
        dispatch(change('formHeaderSearchfilter', 'typeHNX', _.some(_filterIndex, o => o === 'HNX')));
        dispatch(change('formHeaderSearchfilter', 'typeUPCOM', _.some(_filterIndex, o => o === 'UPCOM')));

        dispatch(change('formHeaderSearchfilter', 'typeIndustry', _filter.IndustryCode ?? Object.keys(mapIndustryList).join(',')));

        const _fil = {
          filter: formPersonalFilter,
          name: _filter?.Name,
          index: _filter?.ExchangeCode,
          industry: _filter?.IndustryCode ?? Object.keys(mapIndustryList).join(','),
        };
        setHeaderFilter(_fil);
      }
    }
  }, [formPersonalFilter]);

  // React.useEffect(() => {
  //   if (formChkApec === '1') {
  //     // typeHOSE,
  //     // typeHNX,
  //     // typeUPCOM,
  //     dispatch(change('formHeaderSearchfilter', 'typeHOSE', true));
  //     dispatch(change('formHeaderSearchfilter', 'typeHNX', true));
  //     dispatch(change('formHeaderSearchfilter', 'typeUPCOM', true));
  //     dispatch(change('formHeaderSearchfilter', 'typeIndustry', ''));
  //     dispatch(change('formHeaderSearchfilter', 'formPersonalFilter', ''));
  //     const _fil = {
  //       filter: 'APEC',
  //       name: 'APEC',
  //       index: 'HOSE,HNX,UPCOM',
  //       industry: '',
  //     };
  //     setHeaderFilter(_fil);
  //   }
  // }, [formChkApec]);

  React.useEffect(() => {
    if (analUserFilter && !_.isEqual(analUserFilter, preUserFilter)) {
      if(!!analUserFilter.length ) {
        console.log('formSearchFilter', analUserFilter, preUserFilter);
        const _filterFirst = analUserFilter[0];
        const _filterIndex = _filterFirst.ExchangeCode?.split(',') || ['HOSE', 'HNX', 'UPCOM'];
  
        dispatch(change('formHeaderSearchfilter', 'formPersonalFilter', _filterFirst.FilterId))
        dispatch(change('formHeaderSearchfilter', 'typeIndustry', _filterFirst.IndustryCode ?? Object.keys(mapIndustryList).join(',')))
        dispatch(change('formHeaderSearchfilter', 'typeHOSE', _.some(_filterIndex, o => o === 'HOSE')));
        dispatch(change('formHeaderSearchfilter', 'typeHNX', _.some(_filterIndex, o => o === 'HNX')));
        dispatch(change('formHeaderSearchfilter', 'typeUPCOM', _.some(_filterIndex, o => o === 'UPCOM'))); 
      } else {
        setHeaderFilter(null)
      }
    }

  }, [analUserFilter]);

  function submit(values) {
    return;
  }

  const { handleSubmit, lang } = props;

  return (
    <form
      className="form-search-head d-flex w-100 align-items-center"
      onSubmit={handleSubmit(submit)}
    >
      <span className="mr-auto">
        {t('algo.lcp.txt-Filters')}:{' '}
        {formPersonalFilter
          ? _.find(analUserFilter, (o) => o.FilterId == formPersonalFilter)
              ?.Name
          : t('algo.lcp.txt-Your-Filters')}
      </span>

      <Form.Group className="d-flex mb-0" controlId="formPlaintextSymbol">
        {/* <Field
          name="formChkApec"
          className="form-control fz-13 mr-2 d-flex align-items-center w-auto"
          component={RenderChkLikeBtn}
          label={'Bộ lọc từ APEC'}
        /> */}

        <Field
          name="formPersonalFilter"
          component="select"
          className="form-control fz-13 w-auto filter-personal-icon"
        >
          {(!analUserFilter || !analUserFilter.length) && (
            <option value="">{t('algo.lcp.txt-Your-Filters')}</option>
          )}
          {analUserFilter &&
            analUserFilter.map((item) => (
              <option value={item.FilterId} key={item.FilterId}>
                {item.Name}
              </option>
            ))}
        </Field>
        <label className="txt-content fz-13 mx-2 text-nowrap">{t('algo.lcp.txt-Exchange')}:</label>
        <Field
          name="typeHOSE"
          component={RenderFieldCheckbox}
          labelName="HOSE"
        />
        <Field name="typeHNX" component={RenderFieldCheckbox} labelName="HNX" />
        <Field
          name="typeUPCOM"
          component={RenderFieldCheckbox}
          labelName="UPCOM"
        />
        <label className="txt-content fz-13 mx-2 text-nowrap">{t('algo.lcp.txt-Industry')}:</label>
        <Field
          name="typeIndustry"
          component={RenderMultiSelect}
          className="form-select-multi"
          lang={lang}
          theme={theme}
          opts={Object.entries(mapIndustryList).map(([key, value]) => ({
            value: key,
            label: t('algo.industry.' + key),
          }))}
        />
        {/* <option value="">Tất cả</option>
          {mapIndustryList &&
            Object.keys(mapIndustryList).map((item) => (
              <option value={item} key={item}>
                {mapIndustryList[item]}
              </option>
            ))} */}
        {/* </Field> */}
      </Form.Group>
    </form>
  );
}

FormSearchFilter = reduxForm({
  form: 'formHeaderSearchfilter',
  enableReinitialize: true,
})(FormSearchFilter);

const selector = formValueSelector('formHeaderSearchfilter');

const makeMapStateToProps = () => {
  const getAnalUserFilter = makeGetAnalUserFilter();

  const mapStateToProps = (state) => {
    const {
      formChkApec,
      formPersonalFilter,
      typeHOSE,
      typeHNX,
      typeUPCOM,
      typeIndustry,
    } = selector(
      state,
      'formChkApec',
      'formPersonalFilter',
      'typeHOSE',
      'typeHNX',
      'typeUPCOM',
      'typeIndustry'
    );

    return {
      analUserFilter: getAnalUserFilter(state),
      lang: state.client?.setting?.lang || 'vi',
      formChkApec,
      formPersonalFilter,
      typeHOSE,
      typeHNX,
      typeUPCOM,
      typeIndustry,
      initialValues: {
        formChkApec: '',
        formPersonalFilter: '',
        typeHOSE: true,
        typeHNX: true,
        typeUPCOM: true,
        typeIndustry: '',
      },
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(FormSearchFilter);
